import { Route, Switch } from 'react-router-dom';
import { CATALOG_ROUTES } from './catalogRoutes';
import { MetaplansListPage } from './Subscriptions/pages';

function Subscriptions(): JSX.Element {
  return (
    <Switch>
      <Route path={CATALOG_ROUTES.metaplansList} exact>
        <MetaplansListPage />
      </Route>
    </Switch>
  );
}

export default Subscriptions;
